import { Dialog } from "../../../../../../common/core-ui/Dialog.tsx";
import { useIntl } from "react-intl";
import useReadOffline from "./useReadOffline.ts";

export default function LaunchingAppDialog({
  onRequestClose,
  designatedDownloadAppUrl,
}: {
  onRequestClose: () => void;
  designatedDownloadAppUrl?: string;
}) {
  const intl = useIntl();
  const { downloadAppUrl: derivedDownloadAppUrl } = useReadOffline();

  return (
    <Dialog
      disableFullScreen
      size="small"
      onRequestClose={onRequestClose}
      title={intl.formatMessage({
        defaultMessage: "Launching app on your device...",
      })}
      primaryButton={{
        href: designatedDownloadAppUrl ?? derivedDownloadAppUrl,
        label: intl.formatMessage({ defaultMessage: "Download" }),
      }}
      secondaryButton={{
        onClick: onRequestClose,
        label: intl.formatMessage({ defaultMessage: "Cancel" }),
      }}
    >
      {intl.formatMessage({
        defaultMessage:
          "If nothing is happening, you might not have the app downloaded or ad blockers may be enabled.",
      })}
    </Dialog>
  );
}
